import Vue from 'vue'
import {getToken} from "@/api/auth"
import Router from 'vue-router'
import login from '@/pages/login/index' //登录
// import login from '@/pages/login/index2' //登录
import index from '@/pages/index/index' //首页
import product from '@/pages/product/index' //礼品商城
import join from '@/pages/join/index' //分站加盟
import user from '@/pages/user/index' //会员中心
import service from '@/pages/service/index' //收费标准
import order from '@/pages/order/add' //我要发货
import recharge from '@/pages/recharge/index' //我要充值
import walletLog from '@/pages/wallet/log' //资金明细
import withdrawal from '@/pages/withdrawal/index' //提现
import orderList from '@/pages/order/lst' //我的订单
import packagelst from '@/pages/order/packagelst' //我的包裹
import aftermarket from '@/pages/aftermarket/index' //售后申请
import invitation from '@/pages/invitation/index' //邀请好友
import help from '@/pages/help/index' //代发指南
import news from '@/pages/news/index' //帮助中心
import detail from '@/pages/news/detail' //帮助中心
import forget from '@/pages/login/forget' //忘记密码
import feedback from '@/pages/feedback/index' //意见反馈
import depot from '@/pages/depot/index' //仓储地址


import dome from '@/pages/dome/index' //测试

var routerPush = Router.prototype.push
Router.prototype.push = function push(location){
  return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/product',
      name: 'product',
      component: product
    },
    {
      path: '/join',
      name: 'join',
      component: join
    },
    {
      path: '/user',
      name: 'user',
      component: user
    },
    {
      path: '/service',
      name: 'service',
      component: service
    },
    {
      path: '/order/add',
      name: 'order',
      component: order
    },
    {
      path: '/order/lst',
      name: 'orderList',
      component: orderList
    },
    {
      path: '/order/packagelst',
      name: 'packagelst',
      component: packagelst
    },
    {
      path: '/recharge',
      name: 'recharge',
      component: recharge
    },
    {
      path: '/walletLog',
      name: 'walletLog',
      component: walletLog
    },
    {
      path: '/withdrawal',
      name: 'withdrawal',
      component: withdrawal
    },
    {
      path: '/aftermarket',
      name: 'aftermarket',
      component: aftermarket
    },
    {
      path: '/invitation',
      name: 'invitation',
      component: invitation
    },
    {
      path: '/help',
      name: 'help',
      component: help
    },
    {
      path: '/news',
      name: 'news',
      component: news
    },
    {
      path: '/about',
      name: 'about',
      component: detail
    },
    {
      path: '/news/detail',
      name: 'newsDetail',
      component: detail
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/login/forget',
      name: 'forget',
      component: forget
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: feedback
    },
    {
      path: '/depot',
      name: 'depot',
      component: depot
    },


    {
      path: '/dome',
      name: 'dome',
      component: dome
    },
  ]
})

const whiteList = ['/', 'index', '/login', '/join', '/feedback', '/login/forget', '/news', '/news/detail', '/help'] //免登录白名单

router.beforeEach((to, from, next) => {
  if (getToken()) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      next({to, replace: true})
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login`) // 否则全部重定向到首页
    }
  }
})


export default router;


// WEBPACK FOOTER //
// ./src/router/index.js